import React from 'react';
import type { AppointmentTaker } from '../../marketplace/types';
import { ConsultantCard } from './ConsultantCard';

interface ConsultantCardGridProps {
  takers: AppointmentTaker[];
}

const ConsultantCardGrid: React.FC<ConsultantCardGridProps> = ({ takers }) => (
  <div className="catalog-grid">
    {takers.map((taker, index) => (
      <div key={taker.userId} className="catalog-grid-item">
        <ConsultantCard taker={taker} index={index} />
      </div>
    ))}
  </div>
);

export default ConsultantCardGrid;
